import { Modal } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import {
  ConnectedVendorDetail,
  type IConnectedVendorDetailProps,
} from './ConnectedVendorDetail'
import messages from './messages'

export interface IConnectedVendorDetailModalProps
  extends IConnectedVendorDetailProps {
  open?: boolean
  onDismiss?: () => void
}

export const ConnectedVendorDetailModal = ({
  open = false,
  onDismiss = () => undefined,
  ...ConnectedVendorDetailProps
}: IConnectedVendorDetailModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      aria-labelledby='ConnectedVendorDetail-modal-title'
      maxWidth='md'
      open={open}
      onClose={onDismiss}
      disableEnforceFocus
    >
      <Modal.Card>
        <Modal.Header
          id='ConnectedVendorDetail-modal-title'
          onClose={onDismiss}
        >
          {intl.formatMessage(messages.modalTitle)}
        </Modal.Header>
        <Modal.Content>
          <ConnectedVendorDetail {...ConnectedVendorDetailProps} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}

ConnectedVendorDetailModal.displayName = 'ConnectedVendorDetailModal'
